
import BackButton from "../components/buttons/Back.vue";
import Checkbox from "../components/form/Checkbox.vue";
import Button from "../components/buttons/Button.vue";
import RateBook from "../components/RateBook.vue";
import Modal from "../components/Modal.vue";
import { defineComponent, onMounted, watch } from "vue";
import { polishTranslate } from "@book-searcher/data";
import { capitalize } from "../utils/functions";
import { useBook } from "../utils/composable/useBook";
export default defineComponent({
  name: "Result",
  components: {
    BackButton,
    Checkbox,
    RateBook,
    Modal,
    Button,
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  setup(prp) {
    const {
      book,
      getBook,
      isBookInUserLibrary,
      addBookToUserLibrary,
      deleteBookFromUserLibrary,
    } = useBook();

    getBook(prp.slug);

    const handleManageUserLibrary = () => {
      if (isBookInUserLibrary.value) {
        return deleteBookFromUserLibrary(book.value.id);
      }

      return addBookToUserLibrary(book.value.id);
    };

    onMounted(() => {
      window.scrollTo(0, 0);
    });

    watch(book, () => {
      document.title =
        book.value.name + " · " + book.value.author ?? "Book Searcher";
    });

    return {
      book,
      capitalize,
      polishTranslate,
      isBookInUserLibrary,
      handleManageUserLibrary,
    };
  },
});
